import { render, staticRenderFns } from "./GalleryArtworkInformationPanel.vue?vue&type=template&id=1f6d2e99&scoped=true&"
import script from "./GalleryArtworkInformationPanel.vue?vue&type=script&lang=ts&"
export * from "./GalleryArtworkInformationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryArtworkInformationPanel.vue?vue&type=style&index=0&id=1f6d2e99&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d2e99",
  null
  
)

export default component.exports